import React from "react";
import styles from "./transaction.module.css";

function TransactionOtherDetail({ canvasData }) {
  return (
    <table className={styles.details}>
      <tbody>
        {canvasData.transaction_type === "TRANSFER" && (
          <>
            <tr>
              <td>Beneficiary Name:</td>
              <td className={styles.textMuted}>
                {canvasData.to_account_user_name || "--"}
              </td>
            </tr>
            <tr>
              <td>Beneficiary Account Number:</td>
              <td className={styles.textMuted}>
                {canvasData.to_account_account_no || "--"}
              </td>
            </tr>
          </>
        )}
        <tr>
          <td>Beneficiary Account ID:</td>
          <td className={styles.textMuted}>
            {canvasData.transaction_to_account_id || "--"}
          </td>
        </tr>

        <tr>
          <td>From Account Name:</td>
          <td className={styles.textMuted}>
            {["FUND_RECEIVED", "FUND_RECEIVED_LIEN", "REFUND"].includes(canvasData.transaction_type)
              ? canvasData.transaction_from_account_desc || "--"
              : canvasData.from_account_user_name || "--"}
          </td>
        </tr>
        {canvasData.transaction_type !== "FUND_RECEIVED" && (
          <tr>
            <td>From Account Number:</td>
            <td className={styles.textMuted}>
              {canvasData.from_account_account_no || "--"}
            </td>
          </tr>
        )}
        {canvasData.transaction_type === "CONVERSION" && (
          <tr>
            <td>To Account Number:</td>
            <td className={styles.textMuted}>
              {canvasData.to_account_account_no || "--"}
            </td>
          </tr>
        )}
        <tr>
          <td>From Currency:</td>
          <td className={styles.textMuted}>
            {canvasData.transaction_from_currency || "--"}
          </td>
        </tr>
        <tr>
          <td>To Currency:</td>
          <td className={styles.textMuted}>
            {canvasData.transaction_to_currency || "--"}
          </td>
        </tr>
        {canvasData.transaction_type !== "CONVERSION" && (
          <tr>
            <td>Transfer Method:</td>
            <td className={styles.textMuted}>
              {canvasData.transaction_transfer_method === "LOCAL"
                ? "Borderless Instant"
                : canvasData.transaction_transfer_method || "--"}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default TransactionOtherDetail;
